const state = () => ({
    ending: []
})

const mutations = {
    setVideos(state, { video }) {
        state.ending[0] = video
    },
    clearAll(state) {
        state.ending = []
    }
}

const actions = {
    async setVideos({ commit }, { video }) {
        commit('setVideos', { video })
    },
    async clearAll({ commit }) {
        commit('clearAll')
    }
}

const getters = {
    ending: state => state.ending
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};